/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Při zpracování vaší objednávky došlo k chybě. Prosím zkuste znovu.`
};

const da_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl under behandlingen af din ordre. Prøv venligst igen.`
};

const de_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Verarbeiten Ihrer Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`
};

const en_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred while processing your order. Please try again.`
};

const es_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error al procesar tu pedido. Por favor, inténtalo de nuevo.`
};

const fr_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors du traitement de votre commande. Veuillez réessayer.`
};

const hu_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a rendelés feldolgozása során. Kérjük, próbálkozz újra.`
};

const it_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante l'elaborazione dell'ordine. Riprova.`
};

const nl_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden bij het verwerken van je bestelling. Probeer het opnieuw.`
};

const pl_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd podczas przetwarzania zamówienia. Spróbuj ponownie.`
};

const pt_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro ao processar seu pedido. Por favor, tente novamente.`
};

const sv_checkout_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod vid behandlingen av din beställning. Försök igen.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_error", locale)
	if (locale === "cs") return cs_checkout_error(inputs)
	if (locale === "da") return da_checkout_error(inputs)
	if (locale === "de") return de_checkout_error(inputs)
	if (locale === "en") return en_checkout_error(inputs)
	if (locale === "es") return es_checkout_error(inputs)
	if (locale === "fr") return fr_checkout_error(inputs)
	if (locale === "hu") return hu_checkout_error(inputs)
	if (locale === "it") return it_checkout_error(inputs)
	if (locale === "nl") return nl_checkout_error(inputs)
	if (locale === "pl") return pl_checkout_error(inputs)
	if (locale === "pt") return pt_checkout_error(inputs)
	return sv_checkout_error(inputs)
};
export { checkout_error as "checkout.error" }